import CheckView from "@/refund/views/check";

const Check: React.FC = () => <CheckView />;
export default Check;
